module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.apiLoading) ? _c('div', {
    staticClass: "container-fluid page-head-wrap"
  }, [_c('div', {
    staticClass: "container page-head text-center"
  }, [_c('p', {
    staticClass: "mb-0"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-pulse fa-fw",
    staticStyle: {
      "font-size": "14px"
    }
  }), _vm._v(" "), _c('trans-text', {
    attrs: {
      "i18nKey": "ui['5_4_1'][101]"
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('page-content', {
    ref: "pageContent",
    attrs: {
      "event": _vm.event,
      "cart": _vm.cart,
      "totalCount": _vm.totalCount,
      "totalPrice": _vm.totalPrice,
      "isShowCategoryPopover": _vm.isShowCategoryPopover
    },
    on: {
      "refleshTotal": _vm.refleshTotal,
      "selectCategory": _vm.selectCategory,
      "toggleIsShowCategoryPopover": _vm.toggleIsShowCategoryPopover
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6b03ab20!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/subPages/Order/Catalog.vue
// module id = 711
// module chunks = 0